<template>
    <FullPageScroller
        :sections-count="sections.length + 1"
        :enable-scroll="!isShowingDetails && !showDrawer"
        v-model="activeSectionIndex"
    >
        <BrandBookHomeHero
            :is-active="activeSectionIndex === 0"
            :style="{ 'z-index': sections.length + 1 }"
            @go-next="goNextSection"
        />

        <BrandBookSection
            v-for="(section, index) in sections"
            :key="index"
            :is-previous="activeSectionIndex - 1 < index"
            :is-after="activeSectionIndex - 1 > index"
            :style="{ 'z-index': sections.length - index }"
            :is-last="index === sections.length - 1"
            :call-to-open="callToOpen"
            v-bind="section"
            @show-details="isShowingDetails = $event"
            @go-next="goNextSection"
        >
            <template v-if="section.heroComponent" #hero>
                <component :is="section.heroComponent" />
            </template>
            <component :is="section.component" />
        </BrandBookSection>

        <transition name="fade">
            <div v-if="!isShowingDetails && !showDrawer">
                <div
                    class="brand-book-links pos-fixed pos-top pos-right d-inline-flex flex-align-center z-max"
                >
                    <a
                        class="brand-book-link border rounded-full border-white border-2 border-solid shadow-5 px"
                        href="/"
                        target="_blank"
                    >
                        <span class="hidden-sm-down">Visite nossa loja</span>
                        <span class="hidden-sm-up">Loja</span>
                    </a>
                </div>
            </div>
        </transition>

        <transition name="fade">
            <BrandBookSideBar
                v-if="!isShowingDetails"
                :titles="sectionsTitles"
                :active-section-index="activeSectionIndex"
                @click="activeSectionIndex = $event"
            />
        </transition>

        <BrandBookDrawer
            v-show="!isShowingDetails"
            v-model="showDrawer"
            :active-section-index="activeSectionIndex"
            :titles="sectionsTitles"
            :animation-duration="animationDuration"
            @click="activeSectionIndex = $event"
        />
    </FullPageScroller>
</template>

<script>
    import BrandBookSection from '../brand-book-6/BrandBookSection';
    import BrandBookNavigation from '../brand-book-6/BrandBookNavigation';
    import BrandBookAbout from '../brand-book/sections/BrandBookAbout';
    import BrandBookVoice from '../brand-book/sections/BrandBookVoice';
    import BrandBookLogo from '../brand-book/sections/BrandBookLogo';
    import BrandBookFashion from '../brand-book/sections/BrandBookFashion';
    import BrandBookColors from '../brand-book/sections/BrandBookColors';
    import BrandBookElements from '../brand-book/sections/BrandBookElements';
    import BrandBookHierarchy from '../brand-book/sections/BrandBookHierarchy';
    import BrandBookIllustrations from '../brand-book/sections/BrandBookIllustrations';
    import BrandBookHomeHero from './BrandBookHomeHero';
    import { updateLazyLoad } from '../../../common/common';
    import FullPageScroller from './FullPageScroller';
    import BrandBookSideBar from './BrandBookSideBar';
    import BrandBookDrawer from './BrandBookDrawer';
    import BrandBookColorsHero from '../brand-book/sections-hero/BrandBookColorsHero';
    import BrandBookAboutHero from '../brand-book/sections-hero/BrandBookAboutHero';
    import BrandBookVoiceHero from '../brand-book/sections-hero/BrandBookVoiceHero';
    import BrandBookLogoHero from '../brand-book/sections-hero/BrandBookLogoHero';
    import BrandBookFashionHero from '../brand-book/sections-hero/BrandBookFashionHero';
    import BrandBookElementsHero from '../brand-book/sections-hero/BrandBookElementsHero';
    import BrandBookHierarchyHero from '../brand-book/sections-hero/BrandBookHierarchyHero';
    import BrandBookIllustrationsHero from '../brand-book/sections-hero/BrandBookIllustrationsHero';

    export default {
        name: 'BrandBook',

        el: '#brand-book-vue',

        components: {
            BrandBookDrawer,
            BrandBookSideBar,
            FullPageScroller,
            BrandBookHomeHero,
            BrandBookIllustrations,
            BrandBookHierarchy,
            BrandBookElements,
            BrandBookColors,
            BrandBookFashion,
            BrandBookLogo,
            BrandBookVoice,
            BrandBookAbout,
            BrandBookNavigation,
            BrandBookSection,
            BrandBookIllustrationsHero,
            BrandBookHierarchyHero,
            BrandBookElementsHero,
            BrandBookColorsHero,
            BrandBookFashionHero,
            BrandBookLogoHero,
            BrandBookVoiceHero,
            BrandBookAboutHero,
        },

        data() {
            return {
                animationDuration: 750,
                callToOpen: true,
                showDrawer: false,
                isShowingDetails: false,
                activeSectionIndex: 0,
                sections: [
                    {
                        title: 'A Marca',
                        color: 'orange',
                        component: 'BrandBookAbout',
                        heroComponent: 'BrandBookAboutHero',
                    },
                    {
                        title: 'Tom de voz',
                        color: 'blue',
                        component: 'BrandBookVoice',
                        heroComponent: 'BrandBookVoiceHero',
                    },
                    {
                        title: 'Logomarca',
                        color: 'orange',
                        component: 'BrandBookLogo',
                        heroComponent: 'BrandBookLogoHero',
                        large: true,
                    },
                    {
                        title: 'Produção de moda',
                        color: 'blue',
                        component: 'BrandBookFashion',
                        heroComponent: 'BrandBookFashionHero',
                        large: true,
                    },
                    {
                        title: 'Cores',
                        color: 'orange',
                        component: 'BrandBookColors',
                        heroComponent: 'BrandBookColorsHero',
                        large: true,
                    },
                    {
                        title: 'Elementos básicos de composição',
                        color: 'blue',
                        component: 'BrandBookElements',
                        heroComponent: 'BrandBookElementsHero',
                    },
                    {
                        title: 'Hierarquia',
                        color: 'orange',
                        component: 'BrandBookHierarchy',
                        heroComponent: 'BrandBookHierarchyHero',
                    },
                    {
                        title: 'Ilustrações',
                        color: 'blue',
                        component: 'BrandBookIllustrations',
                        heroComponent: 'BrandBookIllustrationsHero',
                    },
                ],
            };
        },

        mounted() {
            updateLazyLoad();
        },

        computed: {
            sectionsTitles() {
                return ['Início', ...this.sections.map((section) => section.title)];
            },
        },

        watch: {
            isShowingDetails() {
                this.callToOpen = false;
            },
        },

        methods: {
            goNextSection() {
                this.activeSectionIndex = Math.min(
                    this.sections.length,
                    this.activeSectionIndex + 1
                );
            },
        },
    };
</script>